import React from 'react'
import { CustomMarkerIcon, CustomMarkerIconProps } from './custom-marker-icon'
import { InitialsIconProps, InitialsMarkerIcon } from './initials-marker-icon'
import { PolygonMarkerIcon, PolygonMarkerIconProps } from './polygon-marker-icon'
import { PolylineMarkerIcon, PolylineMarkerIconProps } from './polyline-marker-icon'

export interface MarkerIconProps {
  markerStyle?: string
}

export function MarkerIcon({
  marker,
  isLarge,
}: {
  marker: InitialsIconProps | CustomMarkerIconProps | PolygonMarkerIconProps | PolylineMarkerIconProps
  isLarge?: boolean
}) {
  let markerComponent = null

  if ('initials' in marker) {
    markerComponent = (
      <InitialsMarkerIcon
        initials={marker.initials}
        customType={marker.customType}
        markerStyle={marker.markerStyle}
        isLarge={isLarge}
      />
    )
  } else if ('iconFilePath' in marker) {
    markerComponent = <CustomMarkerIcon iconFilePath={marker.iconFilePath} isLarge={isLarge} />
  } else if ('color' in marker) {
    markerComponent = <PolylineMarkerIcon marker={marker} isLarge={isLarge} />
  } else if ('borderColor' in marker) {
    markerComponent = <PolygonMarkerIcon marker={marker} isLarge={isLarge} />
  }

  return markerComponent
}
